import { ServiceCategories as Page } from './ServiceCategories.main';
import { ServiceCategoriesHeader as Header } from './ServiceCategoriesHeader';

export const ServiceCategories = { Header, Page };
